import request from '../untils/request';

export const tradingOrderListApi = params => {
  return request({
    url: '/order/order/index',
    authCode: 'ORDER_INDEX',
    params,
  });
};

export const tradingOrderCancelApi = params => {
  return request({
    url: '/order/order/cancel',
    authCode: 'ORDER_EDIT',
    params,
  });
};

export const tradingOrderDetailApi = params => {
  return request({
    url: '/order/order/detail',
    authCode: 'ORDER_EDIT',
    params,
  });
};

export const tradingOrderMoneyReceiveApi = params => {
  return request({
    url: '/order/order/receive',
    authCode: 'ORDER_EDIT',
    params,
  });
};

export const tradingOrderChildrenApi = params => {
  return request({
    url: '/order/order/child-orders',
    authCode: 'ORDER_EDIT',
    params,
  });
};

export const tradingOrderPostChildrenApi = params => {
  return request({
    url: '/order/order/inside-child-orders',
    authCode: 'ORDER_EDIT',
    params,
  });
};

export const tradingOrderPostGoodsApi = params => {
  return request({
    url: '/order/order/send-goods',
    authCode: 'ORDER_EDIT',
    params,
  });
};

export const tradingEditAchiApi = params => {
  return request({
    url: '/order/order-sub/edit-achi',
    authCode: 'ORDER_EDIT',
    params,
  });
};

export const tradingAddAfterSaleApi = params => {
  return request({
    url: '/order/order-sub/add-after-sale',
    authCode: 'ORDER_EDIT',
    params,
  });
};

export const tradingOrderSubRemarkApi = params => {
  return request({
    url: '/order/order-sub/add-remark',
    authCode: 'ORDER_EDIT',
    params,
  });
};

export const tradingRefundReasonApi = params => {
  return request({
    url: '/order/order-sub/refund-reason',
    authCode: 'ORDER_EDIT',
    params,
  });
};

export const tradingOrderLogApi = params => {
  return request({
    url: '/order/order/order-log',
    authCode: 'ORDER_EDIT',
    params,
  });
};

export const tradingOrderGetRemarksApi = params => {
  return request({
    url: '/order/order-sub/get-remarks',
    authCode: 'ORDER_EDIT',
    params,
  });
};

export const tradingOrderPackageApi = params => {
  return request({
    url: '/order/order/package-list',
    authCode: 'ORDER_EDIT',
    params,
  });
};

export const tradingRefundListApi = params => {
  return request({
    url: '/order/order-refund/index',
    authCode: 'ORDER-REFUND_INDEX',
    params,
  });
};

export const tradingRefundDetailApi = params => {
  return request({
    url: '/order/order-refund/detail',
    authCode: 'ORDER-REFUND_EDIT',
    params,
  });
};

export const tradingRefundLogsApi = params => {
  return request({
    url: '/order/order-refund/order-logs',
    authCode: 'ORDER-REFUND_EDIT',
    params,
  });
};

export const tradingRefundAgreeApi = params => {
  return request({
    url: '/order/order-refund/refund-money',
    authCode: 'ORDER-REFUND_EDIT',
    params,
  });
};

export const tradingRefundOperateApi = params => {
  return request({
    url: '/order/order-refund/operate',
    authCode: 'ORDER-REFUND_EDIT',
    params,
  });
};

export const tradingRefundGetRemarksApi = params => {
  return request({
    url: '/order/order-refund/get-remarks',
    authCode: 'ORDER-REFUND_EDIT',
    params,
  });
};

export const tradingRefundResetApi = params => {
  return request({
    url: '/order/order-refund/reset',
    authCode: 'ORDER-REFUND_EDIT',
    params,
  });
};

export const tradingReturnResetApi = params => {
  return request({
    url: '/order/order-return/reset',
    authCode: 'ORDER-REFUND_EDIT',
    params,
  });
};

export const tradingRefundKaAchiApi = params => {
  return request({
    url: '/order/order-refund/ka-achi',
    authCode: 'ORDER-REFUND_EDIT',
    params,
  });
};

export const tradingReturnKaAchiApi = params => {
  return request({
    url: '/order/order-return/ka-achi',
    authCode: 'ORDER-RETURN_EDIT',
    params,
  });
};

export const tradingReturnShopOrderApi = params => {
  return request({
    url: '/order/order-return/shop-order',
    authCode: 'ORDER-RETURN_EDIT',
    params,
  });
};


export const tradingReturnListApi = params => {
  return request({
    url: '/order/order-return/index',
    authCode: 'ORDER-RETURN_INDEX',
    params,
  });
};

export const tradingReturnDetailApi = params => {
  return request({
    url: '/order/order-return/detail',
    authCode: 'ORDER-RETURN_EDIT',
    params,
  });
};
export const tradingReturnDetailApiNew = params => {
  return request({
    url: '/order/order-return/detail-new',
    authCode: 'ORDER-RETURN_CONFIRM_RECEIVED',
    params,
  });
};

export const tradingReturnSaveExporessApi = params => {
  return request({
    url: '/order/order-return/save-express-info',
    authCode: 'ORDER-RETURN_EDIT',
    params,
  });
};

export const tradingReturnReceiveApi = params => {
  return request({
    url: '/order/order-return/receive',
    authCode: 'ORDER-RETURN_EDIT',
    params,
  });
};

export const tradingReturnConfirmApi = params => {
  return request({
    url: '/order/order-return/confirm',
    authCode: 'ORDER-RETURN_EDIT',
    params,
  });
};

export const tradingReturnRemarkApi = params => {
  return request({
    url: '/order/order-return/remark',
    authCode: 'ORDER-RETURN_EDIT',
    params,
  });
};

export const tradingReturnMoneyBackApi = params => {
  return request({
    url: '/order/order-return/refund-money',
    authCode: 'ORDER-RETURN_EDIT',
    params,
  });
};

export const tradingReturnLogsApi = params => {
  return request({
    url: '/order/order-return/order-logs',
    authCode: 'ORDER-RETURN_EDIT',
    params,
  });
};

export const tradingReturnGetRemarksApi = params => {
  return request({
    url: '/order/order-return/get-remarks',
    authCode: 'ORDER-RETURN_EDIT',
    params,
  });
};

export const tradingReturnWithoutReceiveApi = params => {
  return request({
    url: '/order/order-return/no-receive',
    authCode: 'ORDER-RETURN_EDIT',
    params,
  });
};

export const tradingRefundDoRemarksApi = params => {
  return request({
    url: '/order/order-refund/remark',
    params,
  });
};

export const tradingOrderOfflineRefundApi = params => {
  return request({
    url: '/order/order-refund/offline-refund',
    params,
  });
};

export const tradingGiftApi = params => {
  return request({
    url: '/order/gift-record/index',
    authCode: 'GIFT-RECORD_INDEX',
    params,
  });
};

export const tradingGiftGoodsListApi = params => {
  return request({
    url: '/order/gift-record/goods-list',
    authCode: 'WV',
    params,
  });
};

export const tradingGiftAddingApi = params => {
  return request({
    url: '/order/gift-record/add',
    params,
  });
};

export const tradingGiftRecordDetailApi = params => {
  return request({
    url: '/order/gift-record/detail',
    params,
  });
};

export const tradingGiftRecordLogsApi = params => {
  return request({
    url: '/order/gift-record/logs',
    authCode: 'GIFT-RECORD_INDEX',
    params,
  });
};

export const tradingGiftExcelTemplateApi = params => {
  return request({
    url: '/order/gift-record/excel-template',
    params,
  });
};

export const tradingPayCodeSearchApi = params => {
  return request({
    url: '/order/pay-code/index',
    params,
  });
};

export const tradingSearchOrderApi = params => {
  return request({
    url: '/order/pay-code/search-order',
    params,
  });
};

export const tradingPayCodeDropListApi = params => {
  return request({
    url: '/order/pay-code/dropdown-options',
    params,
  });
};

export const tradingPayCodeRefundApi = params => {
  return request({
    url: '/order/pay-code/refund',
    params,
  });
};

export const tradingPayCodeRefundLogListApi = params => {
  return request({
    url: '/order/pay-code/refund-logs',
    authCode: 'PAY-CODE-REFUND_INDEX',
    params,
  });
};

export const tradingPayErrorApi = params => {
  return request({
    url: '/order/pay-error/index',
    authCode: 'PAY-ERROR_INDEX',
    params,
  });
};

export const tradingPayErrorPassApi = params => {
  return request({
    url: '/order/pay-error/pass',
    params,
  });
};

export const tradingPayErrorIgnoreApi = params => {
  return request({
    url: '/order/pay-error/ignore',
    params,
  });
};

export const tradingPayCodeQuerysApi = params => {
  return request({
    url: '/order/pay-code/query-refund',
    params,
  });
};

export const tradingRefundFreightApi = params => {
  return request({
    url: '/order/refund-freight/index',
    params,
  });
};

export const tradingRefundFreightResetApi = params => {
  return request({
    url: '/order/refund-freight/reset',
    params,
  });
};

export const tradingRefundFreightConfirmPayApi = params => {
  return request({
    url: '/order/refund-freight/confirm-pay',
    params,
  });
};

export const tradingRefundFreightOperateApi = params => {
  return request({
    url: '/order/refund-freight/operate',
    params,
  });
};

export const tradingRefundFreightAddApi = params => {
  return request({
    url: '/order/refund-freight/add',
    params,
  });
};

export const tradingRefundErrorListApi = params => {
  return request({
    url: '/order/refund-error/index',
    params,
  });
};

export const tradingRefundErrorOfflineApi = params => {
  return request({
    url: '/order/refund-error/offline-refund',
    params,
  });
};

export const tradingRefundErrorTransferApi = params => {
  return request({
    url: '/order/refund-error/transfer-offline',
    params,
  });
};

export const tradingRefundErrorRefundMoneyApi = params => {
  return request({
    url: '/order/refund-error/refund-money',
    params,
  });
};

export const tradingRefundErrorRemarkApi = params => {
  return request({
    url: '/order/refund-error/remark',
    params,
  });
};

export const tradingRefundErrorGetRemarksApi = params => {
  return request({
    url: '/order/refund-error/get-remarks',
    params,
  });
};

export const tradingRefundErrorIgnoreApi = params => {
  return request({
    url: '/order/refund-error/ignore',
    params,
  });
};

export const tradingRefundErrorBankListApi = params => {
  return request({
    url: '/order/refund-error/bank-list',
    params,
  });
};

export const tradingRefundErrorEditPayInfoApi = params => {
  return request({
    url: '/order/refund-error/edit-pay-user-info',
    params,
  });
};

export const tradingRefundErrorRefundRecordApi = params => {
  return request({
    url: '/order/refund-error/refund-log',
    params,
  });
};

export const tradingSubOrderDetailApi = params => {
  return request({
    url: '/order/order-sub/order-detail',
    params,
  });
};

export const tradingRefundSignApi = params => {
  return request({
    url: '/order/order-return/refund-sign',
    params,
  });
};

// 判断当前发起售后是否走新版逻辑, 判断当前售后是否是二次售后
// use_new_after_sale 是否走新版售后逻辑
// is_refund_multi 是否是多次售后
export const tradingAftersaleCheckApi = params => {
  return request({
    url: '/order/order-sub/new-after-sale-check',
    params,
  });
};

export const tradingOrderSubPackageApi = params => {
  return request({
    url: '/order/order/package-list-after-sale',
    params,
  });
};

// 发起多次售后
export const tradingAddMultiAfterSaleApi = params => {
  return request({
    url: '/order/order-refund-multi/add',
    params,
  });
};

// 多次售后列表
export const tradingRefundMultiListApi = params => {
  return request({
    url: '/order/order-refund-multi/list',
    params,
  });
};

// 多次售后详情
export const tradingRefundMultiDetailApi = params => {
  return request({
    url: '/order/order-refund-multi/detail',
    params,
  });
};

// 多次售后详情内日志
export const tradingRefundMultiLogsApi = params => {
  return request({
    url: '/order/order-refund-multi/get-log',
    params,
  });
};

// 更新子订单定制备注
export const tradingOrderSubCustomizedRemarkApi = params => {
  return request({
    url: '/order/order-sub/save-customized-remark',
    params,
  });
};
